/**
 * The three states every data region must distinguish: loading, loaded-and-empty
 * and failed. Conflating them is how the old app rendered a backend outage as an
 * empty pipeline (docs/16 section 10.2).
 */
import type { CSSProperties, ReactNode } from 'react'
import styles from './ui.module.css'

export function Skeleton({ height = 12, width = '100%', style }: { height?: number | string; width?: number | string; style?: CSSProperties }) {
  return <div className={styles.skeleton} style={{ height, width, ...style }} aria-hidden="true" />
}

export function EmptyState({
  title,
  body,
  action,
}: {
  title: string
  body?: ReactNode
  /** A way out of the dead end: clearing a filter, or asking someone. */
  action?: ReactNode
}) {
  return (
    <div className={styles.state}>
      <p className={styles.stateTitle}>{title}</p>
      {body ? <p className={styles.stateBody}>{body}</p> : null}
      {action}
    </div>
  )
}

export function ErrorState({ title, body, action }: { title: string; body?: string; action?: ReactNode }) {
  return (
    <div className={`${styles.state} ${styles.errorState}`} role="alert">
      <p className={styles.stateTitle}>{title}</p>
      {body ? <p className={styles.stateBody}>{body}</p> : null}
      {action}
    </div>
  )
}

export function Banner({ children }: { children: ReactNode }) {
  return (
    <div className={styles.banner} role="status">
      {children}
    </div>
  )
}
